import {DragableLayout, Icon, Layout, Spacer, Text} from '@di-nxt/components';
import React, {useCallback} from 'react';
import {useLocationColoring} from '../../../../components/shift/useLocationColoring';
import {Task, TaskWithEditInfo} from '../../../../services';

export type Props = {
  task: Task;
  onBeginDrag?: (task: TaskWithEditInfo) => void;
  onEndDrag?: (task: TaskWithEditInfo, didDrop: boolean) => void;
};
export const UnassignedTask: React.FC<Props> = ({
  task,
  onBeginDrag,
  onEndDrag,
}) => {
  const formattedTime = useCallback(() => {
    if (task.durationMinutesEstimated) {
      return (
        Math.floor(task.durationMinutesEstimated / 60) +
        'h ' +
        Math.round(
          (task.durationMinutesEstimated / 60 -
            Math.floor(task.durationMinutesEstimated / 60)) *
            60,
        ) +
        'min'
      );
    }
    return '';
  }, [task.durationMinutesEstimated]);

  const editMode = (task as TaskWithEditInfo).editMode;
  const editing = editMode !== undefined && editMode !== 'dropped';

  const {color} = useLocationColoring(task.hubId);

  return (
    <DragableLayout
      type="Task"
      item={task}
      onBeginDrag={onBeginDrag}
      onEndDrag={onEndDrag}
      borderRadius="8"
      paddingVertical="6"
      backgroundColor={color}
      opacity={editing ? 0.5 : undefined}
      justify="space-between">
      <Layout centered>
        <Layout width={7} />
        <Icon name="package" size="16" filled inverse />
        <Layout width={7} />
        <Text
          textColor="content_mono_inverse_primary"
          variant="inline_12_emphasis">
          {task.name}
        </Text>
      </Layout>
      <Layout centered>
        <Text
          textColor="content_mono_inverse_secondary"
          variant="inline_12_emphasis">
          {formattedTime()}
        </Text>
        <Spacer width="6" />
      </Layout>
    </DragableLayout>
  );
};
